/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-28 14:55:26
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Layout, Card, Tabs } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import FilterOptionTab from './tabs/filter-option-tab';
import FilterTitleTab from './tabs/filter-title-tab';
import MobileButtonTab from './tabs/mobile-button-tab';
import Preview from './preview';

type Props = WithI18nProps;

class StyleSettings extends Component<Props> {
  state = {
    selected: 0
  };

  handleTabChange = selectedTabIndex => {
    this.setState({ selected: selectedTabIndex });
  };

  render() {
    const { selected } = this.state;
    const { i18n } = this.props;
    const tabs = [
      {
        id: 'filter-title',
        content: i18n.translate('AdminHTML.FilterSettings.Common.filterTitle'),
        accessibilityLabel: 'filter-title',
        panelID: 'filter-title'
      },
      {
        id: 'filter-option',
        content: i18n.translate('AdminHTML.FilterSettings.Style.style_Tab2_Content'),
        panelID: 'filter-option'
      },
      {
        id: 'mobile-button',
        content: i18n.translate('AdminHTML.FilterSettings.Style.style_Tab3_Content'),
        panelID: 'mobile-button'
      }
    ];

    const tabComponents = [<FilterTitleTab />, <FilterOptionTab />, <MobileButtonTab />];

    return (
      <div className="style-tabs">
        <Layout>
          <Layout.Section>
            <Card sectioned>
              <div className="left">
                <Tabs tabs={tabs} selected={selected} onSelect={this.handleTabChange}>
                  <Card.Section>{tabComponents[selected]}</Card.Section>
                </Tabs>
              </div>
            </Card>
          </Layout.Section>
          <Layout.Section secondary>
            <div className="right">
              <Preview selected={selected} />
            </div>
          </Layout.Section>
        </Layout>
      </div>
    );
  }
}

export default withI18n()(StyleSettings);
